/**
 * Messages module translations - Tabs section
 */

const tabs = {
  messages: "MESSAGES",
  documentRequests: "DOCUMENT REQUESTS",
  uploadDocuments: "UPLOAD DOCUMENTS",
};

export default tabs;
